import React from 'react';

import './modal-content.scss';

const ModalContent = ({ ytName, showModal, handleModal, video }) => {
  return (
    showModal && (
      <div className={`iframe-wrapper-modal ${showModal ? 'show-modal' : ''}`}>
        <div className="content">
          <p className="bg-white color-blue-100">
            <>
              {ytName && (
                <>
                  <span className="show-tablet-flex">Conoce el {ytName}</span>
                  <span className="show-desktop-flex">Conoce el {ytName}</span>
                </>
              )}
              <button className="close-video-modal color-black-60" type="button" onClick={handleModal}>
                x
              </button>
            </>
          </p>
          <iframe
            height="535"
            src={video}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    )
  );
};

export default ModalContent;
